import { render, staticRenderFns } from "./ParticipantInfoStep.vue?vue&type=template&id=acaf93b6&"
import script from "./ParticipantInfoStep.vue?vue&type=script&lang=ts&"
export * from "./ParticipantInfoStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports